// extracted by mini-css-extract-plugin
export default {"container":"LayoutWrapper_container__SDjey"};